import runValidation from './validationRules.js';

let form_fields= [];
function setFormFieldData(field,rules){
	let validation_rules = {};	
	if(typeof rules === 'string'){
		rules.split('|').map(node=>{
			let ru = node.split(':');
			validation_rules[ru[0]]= ru[1] ? ru[1] : true; 
		});
	}else if(typeof rules === 'object'){
		validation_rules = Object.assign({},rules);
	}else{
		return false;
	}
	form_fields.push({
		'field_name':field,
		'rules':validation_rules,
	});
	return true;
}
const validator = {
	

    form_errors:[],
	
    validateForm: async function(field_name=null, rules=null, input_value=null){
        if(!field_name || !rules){
            throw Error(`missing param:  field_name:${field_name}, rules:${rules}, input_value:${input_value}`);
        }

        setFormFieldData(field_name, rules);
        this.form_errors = [];
        for (let form_field of form_fields){
           
            for (const [key, value] of Object.entries(form_field.rules)) {
                // console.table({key, value,  input_value})
                let validate = runValidation[key]({ input: input_value, value })
                if(!validate.success){
                    // console.log(validate)
                    this.form_errors.push({
                        'success': false,
                        'field_name':field_name,
                        'rule_name':key,
                        'message': validate?.message.replace(':field', field_name)
                    });
                    break;
                };
            }
        }
        
        if(this.form_errors.length){
            let error = this.form_errors[0];
            form_fields.length = 0;
            this.form_errors.length = 0;
            return error;
        }
        form_fields.length = 0;
        return {success: true, field_name: field_name }
          
    },
    collectErrors:function(field){ /* eslint-disable-line no-unused-vars */
        if(this.form_errors){
            return this.form_errors.flatMap(node=>node);
        }
    },
    formErrors:function(field){

        if (!this.form_errors || !this.form_errors.length) {
            return null;
        }
        //get current field errors from this.form_errors 
        let field_error = this.form_errors.find(node=>{
            if(node.form_name) return (node.form_name+'.'+node.field_name)===field;
            return node.field_name===field;
        });

        if(!field_error){
            return '';
        }
        let field_name = field_error.field_name;
        //remove string between brackets and remove underscore
        field_name=field_name.replace(/_/g, ' ').split('#')[0];
        if(this.$t){
            return  this.$t('validation.'+field_error.rule_name,{'attribute': field_name});
        }
        return 
    },
};


export default validator;